import React from "react";
import "../../css/Inicio/inicio.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faBuilding,
  faCalendarDays,
  faFileLines,
  faMoneyBill,
  faUsersLine,
} from "@fortawesome/free-solid-svg-icons";

const botones = [
  {
    texto: "Consulta y Pago de Deuda",
    link: "https://autogestion.ciudaddeoliva.gob.ar",
    color: "verde",
    icono: faMoneyBill,
  },
  {
    texto: "Formulario Cedulón Digital",
    link: "https://forms.gle/GBixAYprGpk1sBUo8",
    color: "naranja",
    icono: faFileLines,
  },
  {
    texto: "Plan Estrategico Urbano",
    link: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/PEU.pdf",
    color: "amarillo",
    icono: faBuilding,
  },
  {
    texto: "Oficina de Empleo",
    link: "/oficina-de-empleo",
    color: "naranja",
    icono: faBriefcase,
  },
  {
    texto: "Calendario de Eventos",
    link: "/calendario-eventos",
    color: "azul",
    icono: faCalendarDays,
  },
  {
    texto: "Concursos Publicos",
    link: "https://ciudaddeoliva.gov.ar/file/pdf/concurso-publicos-2024.pdf",
    color: "amarillo",
    icono: faFileLines,
  },
  {
    texto: "Registro de Emprendedores",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSd0E-RroHMySPG9ZBo2IuP32VZeV8h9aPcAwdxRRQGrbXdncw/viewform",
    color: "naranja2",
    icono: faUsersLine,
  },
];

const Inicio = () => (
  <div>
    <div className="portada">
      <div className="portada-logo" style={{ position: "relative", zIndex: 1 }}>
        <div className="row align-items-center">
          <img src={require("../img/logo-oliva1.png")} className="logoInicio" />
          <hr />
          <a
            href="/censo"
            className="logoCensoLink"
          >
            <img
              src={require("../img/censo-fondo.jpg")}
              className="logoCenso"
              alt="Censo"
            />
          </a>
          <div className="botones-inicio">
            {botones.map((boton, idx) => (
              <a
                key={idx}
                href={boton.link}
                className={`boton-inicio ${boton.color}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={boton.icono} className="iconoBtn" />
                <span className="txtBtnInicio">{boton.texto}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Inicio;
